import errorHandle from '../../../utils/errorHandle';
import { listInactiveTrip } from '../../../api/supportAdmin';

export default async function fetchTripDetails(type, packId, setLoading, setPackData) {
    setLoading(true);
    try {
        const allData = await listInactiveTrip(type, packId);
        setPackData(allData.data);
        setLoading(false);
    } catch (error) {
        setLoading(false);
        errorHandle(error);
    }
}
